import { CLASS_PREFIX } from 'src/constants'

export const AUTH_CLS = `${CLASS_PREFIX}auth`
